module.exports = __webpack_public_path__ + "static/media/contact.a5259bec.png";